import {initScrollTheadTable} from './scroll_thead_table';
import {findApplicant} from './rating_applicants';

$_vikon(() => {
    const key = $_vikon('[name=identity]').val();
    const dataRemoteUri = $_vikon('[name=data_remote_uri]').val();
    const competitionGroupId = $_vikon('[name=competition_group_id]').val();

    $_vikon.ajax({
        type: 'get',
        url: dataRemoteUri + competitionGroupId,
        dataType: 'json',
        data: {},
        headers: {
            Authorization: `Bearer ${key}`,
            Accept: 'application/json; charset=utf-8',
        },
        success: (response) => {
            $_vikon('#ajax_competition_group_applicants').html(response.payload.table);
            initScrollTheadTable();
            findApplicant();
        },
        error: (err) => {
            $_vikon('#ajax_competition_group_applicants').html('Извините, что-то пошло не так. Не удалось получить список конкурсов.');
        },
    });
});
